module.exports = "/assets/data/3c61a5bb908e298c971c18a9c9647550-SK7.data.json";